import { Component, Input } from '@angular/core';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'toaster',
  templateUrl: './toaster.component.html'
})
export class ToasterComponent {

  @Input() type: string = 'success';
  @Input() header: string = 'Success';
  @Input() message: string = 'Success Added';

  constructor(private messageService: MessageService) {
  }

  show() {
    this.messageService.add({ severity: this.type, summary: this.header, detail: this.message });
  }

}
